import React, { Suspense } from "react";

// Keep modal code out of the initial navbar bundle until each modal is opened.
const Logoutmodal = React.lazy(() => import("../../Logout_modal/Logoutmodal"));
const Modals = React.lazy(() => import("../Modals"));
const WelcomeModal = React.lazy(() => import("../../WelcomeModal"));

const NavbarOverlays = ({
  lgShowNotifications,
  name,
  notifications,
  setLgShowNotifications,
  setNotifications,
  setShowLogout,
  setShowWelcomeModal,
  showLogout,
  showWelcomeModal,
}) => (
  <>
    {showLogout && (
      <Suspense fallback={null}>
        <Logoutmodal
          show={showLogout}
          handleClose={() => setShowLogout(false)}
          animation
        />
      </Suspense>
    )}

    {lgShowNotifications && (
      <Suspense fallback={null}>
        <Modals
          setLgShow={setLgShowNotifications}
          lgShow={lgShowNotifications}
          userId={name._id}
          notifications={notifications}
          setNotifications={setNotifications}
        />
      </Suspense>
    )}

    {showWelcomeModal && (
      <Suspense fallback={null}>
        <WelcomeModal
          show={showWelcomeModal}
          handleClose={() => {
            setShowWelcomeModal(false);
            if (name?._id) {
              try {
                localStorage.setItem(`hasSeenWelcomeModal_${name._id}`, "true");
                sessionStorage.setItem(`hasSeenWelcomeModal_${name._id}`, "true");
              } catch (e) {
                console.debug(e);
              }
            }
            sessionStorage.setItem("hasSeenWelcomeModal", "true");
          }}
          userName={name?.fullname || name?.name}
          userId={name?._id}
        />
      </Suspense>
    )}

  </>
);

export { NavbarOverlays };
export default NavbarOverlays;